/**
 * Triggers an analytics page view hit after a successful transition.
 *
 * @param {Router5.Router} router
 */

import Radio from "backbone.radio";
import PageviewModel from "../../models/analytics/pageview";

const channel = Radio.channel("global");

const previousRoutePlugin = () => ({
  onTransitionSuccess: (toState) => {
    // ignore for default route
    if ("home" !== toState.name) {
      // track pageview for all routes, except for the default one
      let title = toState.title;
      const subtitle = toState.subtitle;
      if (subtitle) {
        title = `${title}: ${subtitle}`;
      }

      const data = {
        title,
        location: location.href,
        page: toState.path,
      };

      channel.request("analytics:pageview", new PageviewModel(data));
    }
  },
});

export { previousRoutePlugin as default };
